import { IconProps } from ".";
import { Colors } from "../../styles/colors";

const RectangleIcon = ({ ...props }: IconProps): JSX.Element => {
    return (
        <svg width="200" height="91" viewBox="0 0 200 91" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="200" height="91" fill={props.color ?? Colors.darkBlue} />
        </svg>
    );
};

export default RectangleIcon;
